import * as React from 'react';

export default function ErrorBlock({ msg }: { msg?: string | null | undefined }) {
	return msg ? <span className='help-block'>{msg}</span> : null;
}
